import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function Nav() {
  return (
    <header
      data-testid="luxe-nav"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#0F1117]/75 border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <div className="relative w-9 h-9 rounded-xl bg-grad-primary flex items-center justify-center glow-pink">
            <Sparkles className="w-5 h-5 text-white" strokeWidth={2.5} />
          </div>
          <div className="flex flex-col leading-tight">
            <span className="font-display font-bold text-lg tracking-tight">Reelens</span>
            <span className="text-[10px] text-white/40 font-mono uppercase tracking-widest">AI Growth Audit</span>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-white/70">
          <a href="/#how" className="hover:text-white transition-colors">How it works</a>
          <Link to="/sample" className="hover:text-white transition-colors" data-testid="nav-sample">Sample report</Link>
          <Link to="/blog" className="hover:text-white transition-colors" data-testid="nav-blog">Journal</Link>
          <a href="/#faq" className="hover:text-white transition-colors" data-testid="nav-faq">FAQ</a>
        </nav>
        <Link
          to="/analyze"
          data-testid="nav-cta-btn"
          className="btn-primary text-sm"
        >
          Analyze My Instagram
        </Link>
      </div>
    </header>
  );
}
